import canUseDOM from 'lib/util/canUseDOM';

const globalVideoElement = canUseDOM ? document.createElement('video') : null;

// click handlers will "prime" the video element to allow for "one-click play" by calling "load"
// we only want to do this once
if (canUseDOM) {
    globalVideoElement.prime = () => {
        if (!globalVideoElement.primed) {
            globalVideoElement.load();
            globalVideoElement.primed = true;
        }
    };
}

export default globalVideoElement;



// WEBPACK FOOTER //
// ./app/webapp/player/globalVideoElement.js